import { httpsCallable } from "firebase/functions";
import { functionsClient } from "../firebase";

function normalizeReportRow(row = {}) {
  return {
    id: row.id || "",
    type: row.type || "daily",
    title: row.title || "",
    orgId: row.orgId || "",
    periodStart: Number(row.periodStart || 0),
    periodEnd: Number(row.periodEnd || 0),
    metrics: row.metrics || {},
    milestoneProgress: Array.isArray(row.milestoneProgress) ? row.milestoneProgress : [],
    alerts: Array.isArray(row.alerts) ? row.alerts : [],
    aiSummary: row.aiSummary || null,
    recommendations: Array.isArray(row.recommendations) ? row.recommendations : [],
    createdAt: Number(row.createdAt || 0),
    generatedAt: Number(row.generatedAt || 0),
    jsonDownloadUrl: row.jsonDownloadUrl || "",
    csvDownloadUrl: row.csvDownloadUrl || "",
    summaryDownloadUrl: row.summaryDownloadUrl || "",
    delivery: row.delivery || null,
    emailStatus: row.emailStatus || row.delivery?.status || "",
    emailDelivery: row.emailDelivery || row.delivery || null,
    emailSentAt: Number(row.emailSentAt || 0),
    emailLastAttemptAt: Number(row.emailLastAttemptAt || 0),
    emailLastError: row.emailLastError || "",
    emailProvider: row.emailProvider || row.delivery?.provider || "",
    emailProviderMessageId: row.emailProviderMessageId || row.delivery?.messageId || "",
    emailRelayHttpStatus: Number(row.emailRelayHttpStatus || row.delivery?.relayHttpStatus || 0),
    emailRelayResponseSummary: row.emailRelayResponseSummary || row.delivery?.relayResponseSummary || null,
    resendCount: Number(row.resendCount || 0),
    resendLastAttemptAt: Number(row.resendLastAttemptAt || 0),
  };
}

export async function fetchPilotOperationsState(user, orgId, { max = 12 } = {}) {
  if (!user?.uid || !orgId) return { config: null, reports: [] };
  const call = httpsCallable(functionsClient, "getPilotOperationsState");
  const result = await call({ orgId, max });
  const payload = result?.data || {};
  return {
    config: payload.config || null,
    reports: Array.isArray(payload.reports) ? payload.reports.map(normalizeReportRow) : [],
  };
}

export async function generatePilotReportNow(user, orgId, type = "daily", options = {}) {
  if (!user?.uid || !orgId) return null;
  const callableName = options.backfill ? "backfillPilotReport" : "generatePilotReportNow";
  const call = httpsCallable(functionsClient, callableName);
  const request = {
    orgId,
    type,
  };
  if (options.date) request.date = options.date;
  if (options.periodStart) request.periodStart = Number(options.periodStart);
  if (options.periodEnd) request.periodEnd = Number(options.periodEnd);
  if (options.sendEmail) request.sendEmail = true;
  const result = await call(request);
  const payload = result?.data || {};
  return {
    ok: Boolean(payload.ok),
    skipped: Boolean(payload.skipped),
    reason: payload.reason || "",
    config: payload.config || null,
    report: payload.report ? normalizeReportRow(payload.report) : null,
  };
}

export async function resendPilotReportEmail(user, orgId, reportId) {
  if (!user?.uid || !orgId || !reportId) return null;
  const call = httpsCallable(functionsClient, "resendPilotReportEmail");
  const result = await call({ orgId, reportId });
  const payload = result?.data || {};
  return {
    ok: Boolean(payload.ok),
    reason: payload.reason || "",
    report: payload.report ? normalizeReportRow(payload.report) : null,
  };
}
